// extracted by mini-css-extract-plugin
export default {"cta":"r6","grey":"s6","dark":"t6","chip":"u6","card":"v6","nonclickable":"w6","top":"x6","left":"y6","span":"z6","name":"A6"};
    if(module.hot) {
      // 1711717535533
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  